import CryptoJS from 'crypto-js';

// Clave secreta en formato de bytes
const secretKey = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_KEY);
// Función para desencriptar un valor codificado en Base64
export const decryptValue = (encryptedValue) => {
  // Decodifica el valor de Base64
  const decodedValue = CryptoJS.enc.Base64.parse(encryptedValue);
  // Desencripta el valor usando AES
  const decrypted = CryptoJS.AES.decrypt({ ciphertext: decodedValue }, secretKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  // Convierte el resultado a texto
  return decrypted.toString(CryptoJS.enc.Utf8);
};

// Función para recorrer el JSON y desencriptar los valores
export const decryptJsonValues = (json) => {
  const decryptedObj = {};

  Object.keys(json).forEach((key) => {
    const value = json[key];
    if (typeof value === 'string') {
      const decryptedValue = decryptValue(value);
      
      // Convertir a número si es posible
      if (!isNaN(decryptedValue) && decryptedValue.trim() !== '' && !/^0\d+/.test(decryptedValue)) {
          decryptedObj[key] = Number(decryptedValue);
      } else {
          decryptedObj[key] = decryptedValue;
      }
      
    } else if (typeof value === 'object' && !Array.isArray(value)) {
      decryptedObj[key] = decryptJsonValues(value);
    } else if (Array.isArray(value)) {
      decryptedObj[key] = value.map(item =>
        typeof item === 'object' && item !== null ? decryptJsonValues(item) : item
      );
    } else {
      decryptedObj[key] = value;
    }
  });

  return decryptedObj;
};

// Ejemplo de uso
export const handleDecrypt = (encryptedJson) => {
  return decryptJsonValues(encryptedJson);
};

// ENCRIPTAR LOS VALORES
export const encryptValue = (value) => {
  const encrypted = CryptoJS.AES.encrypt(
    value.toString(),
    secretKey,
    { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
  );
  const base64 = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  return base64
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};
export const decryptValueFromBase64Url = (encryptedBase64Url) => {
  // Base64URL → Base64
  const base64 = encryptedBase64Url
    .replace(/-/g, "+")
    .replace(/_/g, "/")
    .padEnd(encryptedBase64Url.length + (4 - encryptedBase64Url.length % 4) % 4, "=");

  const decodedCipher = CryptoJS.enc.Base64.parse(base64);

  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: decodedCipher },
    secretKey,
    { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
  );

  return decrypted.toString(CryptoJS.enc.Utf8);
};